/*
 * SPDX-FileCopyrightText: 2025 Siemens AG
 *
 * SPDX-License-Identifier: MIT
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

.ag-input-field-input:focus,
.ag-text-field-input:focus {
  box-shadow: none !important;
}

.ag-picker-field-wrapper:focus-within {
  box-shadow: none !important;
}
